(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elzari-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elz-bundle')) {
    customElements.define(
      'elz-bundle',
      class ElzBundle extends HTMLElement {
        connectedCallback() {
          this.items = [];
          this.size = parseInt(this.dataset.size, 10) || 2;
          this.perItem = parseInt(this.dataset.perItem, 10) || 0;
          this.slotsEl = this.querySelector('[data-elz-bundle-slots]');
          this.cta = this.querySelector('[data-elz-bundle-cta]');
          this.querySelectorAll('[data-elz-tier]').forEach((btn) =>
            btn.addEventListener('click', () => this.setSize(parseInt(btn.dataset.elzTier, 10)))
          );
          this.querySelectorAll('[data-elz-bundle-add]').forEach((btn) =>
            btn.addEventListener('click', () => this.add(btn.closest('.elz-bundle__card'), btn))
          );
          this.cta.addEventListener('click', () => this.addToCart());
          this.render();
        }

        money(cents) {
          const format = window.ElzMoneyFormat || 'Rs.[amount]';
          const amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return format.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace('[amount]', amount);
        }

        setSize(size) {
          this.size = size;
          this.items = this.items.slice(0, size);
          this.querySelectorAll('[data-elz-tier]').forEach((btn) => {
            const on = parseInt(btn.dataset.elzTier, 10) === size;
            btn.classList.toggle('is-on', on);
            btn.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          this.render();
        }

        add(card, btn) {
          const option = card.querySelector('[data-elz-bundle-size]').selectedOptions[0];
          if (!option || option.disabled) return;
          if (this.items.length >= this.size) {
            if (window.ElzToast) window.ElzToast.show(this.dataset.fullText);
            return;
          }
          this.items.push({
            id: parseInt(option.value, 10),
            title: card.dataset.title,
            image: card.dataset.image,
            size: option.dataset.size,
            price: parseInt(option.dataset.price, 10),
          });
          btn.classList.add('is-added');
          setTimeout(() => btn.classList.remove('is-added'), 600);
          this.render();
        }

        remove(index) {
          this.items.splice(index, 1);
          this.render();
        }

        render() {
          const count = this.items.length;
          this.querySelector('[data-elz-bundle-count]').textContent = `${count}/${this.size}`;
          this.querySelector('[data-elz-bundle-fill]').style.width = `${Math.round((count / this.size) * 100)}%`;
          // pack prices: N x (highest price - discount per item)
          const maxPrice = parseInt(this.dataset.maxPrice, 10) || 0;
          this.querySelectorAll('[data-elz-tier]').forEach((btn) => {
            btn.querySelector('[data-elz-tier-price]').textContent = this.money(
              parseInt(btn.dataset.elzTier, 10) * (maxPrice - this.perItem)
            );
          });
          this.slotsEl.innerHTML = '';
          for (let i = 0; i < this.size; i += 1) {
            const item = this.items[i];
            const li = document.createElement('li');
            li.className = `elz-bundle__slot${item ? ' is-filled' : ''}`;
            const img = document.createElement('span');
            img.className = 'elz-bundle__slotimg';
            const text = document.createElement('span');
            text.className = 'elz-bundle__slottext';
            if (item) {
              const pic = document.createElement('img');
              pic.src = item.image;
              pic.alt = '';
              img.appendChild(pic);
              const name = document.createElement('b');
              name.textContent = item.title;
              const meta = document.createElement('span');
              meta.textContent = `Size ${item.size} · ${this.money(item.price)}`;
              text.append(name, meta);
              li.append(img, text);
              const x = document.createElement('button');
              x.type = 'button';
              x.className = 'elz-bundle__remove';
              x.setAttribute('aria-label', `Remove ${item.title}, size ${item.size}`);
              x.textContent = '✕';
              x.addEventListener('click', () => this.remove(i));
              li.appendChild(x);
            } else {
              img.textContent = '+';
              img.setAttribute('aria-hidden', 'true');
              const name = document.createElement('b');
              name.textContent = `Product ${i + 1}`;
              text.appendChild(name);
              li.append(img, text);
            }
            this.slotsEl.appendChild(li);
          }
          const full = count === this.size;
          const regular = this.items.reduce((sum, item) => sum + item.price, 0);
          const total = full ? regular - this.perItem * count : this.size * (maxPrice - this.perItem);
          this.querySelector('[data-elz-bundle-total]').textContent = this.money(total);
          this.querySelector('[data-elz-bundle-was]').textContent = full && regular > total ? this.money(regular) : '';
          this.cta.disabled = !full;
        }

        async addToCart() {
          if (this.items.length !== this.size) return;
          this.cta.disabled = true;
          this.cta.setAttribute('aria-busy', 'true');
          try {
            const res = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`.replace('.js.js', '.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: this.items.map((item) => ({ id: item.id, quantity: 1 })),
                sections: 'elz-cart-drawer,cart-icon-bubble',
                sections_url: window.location.pathname,
              }),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.description || data.message || 'cart error');
            this.items = [];
            this.render();
            const drawer = document.querySelector('elz-cart-drawer');
            if (drawer && typeof drawer.show === 'function') {
              drawer.show();
              if (!drawer.applySections(data.sections)) await drawer.refresh();
              if (typeof drawer.focusClose === 'function') drawer.focusClose();
            } else {
              window.location.href = window.routes?.cart_url || '/cart';
            }
          } catch (e) {
            if (window.ElzToast) window.ElzToast.show(e.message || 'Could not add the bundle, please try again');
            this.render();
          } finally {
            this.cta.removeAttribute('aria-busy');
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elzari-collection-grid"]) return;
  try {
    
  document.querySelectorAll('[data-elz-nav-select]').forEach((sel) => {
    sel.addEventListener('change', () => {
      if (sel.value) window.location.href = sel.value;
    });
  });
  document.querySelectorAll('[data-elz-sort-select]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      if (sel.value) url.searchParams.set('sort_by', sel.value);
      else url.searchParams.delete('sort_by');
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elzari-help-tabs"]) return;
  try {
    
  // Preselect a help tab from ?tab=<handle>
  document.addEventListener('DOMContentLoaded', () => {
    const wanted = new URLSearchParams(window.location.search).get('tab');
    if (!wanted) return;
    document.querySelectorAll('[data-elz-tab-handle]').forEach((tab) => {
      if (tab.dataset.elzTabHandle.includes(wanted.toLowerCase())) tab.click();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elzari-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elz-hero-slider')) {
    customElements.define(
      'elz-hero-slider',
      class ElzHeroSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-hs-track]');
          this.slides = [...this.querySelectorAll('[data-hs-slide]')];
          if (!this.track || this.slides.length < 2) return;
          this.wakeSlides();
          this.index = 0;
          this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.slides.forEach((slide, i) => slide.setAttribute('aria-label', `${i + 1} of ${this.slides.length}`));
          // A swipe ends wherever the shopper left it; restart that slide's clock
          let settle;
          this.track.addEventListener(
            'scroll',
            () => {
              if (this.wake) this.wake();
              clearTimeout(settle);
              settle = setTimeout(() => {
                const i = Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
                if (i !== this.index && this.slides[i]) {
                  this.index = i;
                  this.sync();
                }
                this.schedule();
              }, 150);
            },
            { passive: true }
          );
          this.addEventListener('focusin', () => clearTimeout(this.timer));
          this.addEventListener('focusout', () => this.schedule());
          document.addEventListener('visibilitychange', () =>
            document.hidden ? clearTimeout(this.timer) : this.schedule()
          );
          this.addEventListener('shopify:block:select', (event) => {
            const i = this.slides.findIndex((slide) => slide.contains(event.target));
            if (i >= 0) this.go(i, true);
          });
          this.sync();
          this.schedule();
        }

        wakeSlides() {
          // Later slides' images arrive without URLs so they never compete with
          // the first slide (LCP). Fill them in once it has loaded, or as soon
          // as the slider moves.
          const held = [...this.querySelectorAll('img[data-src]')];
          if (!held.length) return;
          let done = false;
          this.wake = () => {
            if (done) return;
            done = true;
            held.forEach((img) => {
              if (img.dataset.srcset) img.srcset = img.dataset.srcset;
              img.src = img.dataset.src;
              img.removeAttribute('data-srcset');
              img.removeAttribute('data-src');
            });
          };
          const later = () => (window.requestIdleCallback || ((cb) => setTimeout(cb, 200)))(this.wake, { timeout: 1500 });
          const first = this.slides[0].querySelector('img');
          if (!first || first.complete) later();
          else {
            first.addEventListener('load', later, { once: true });
            first.addEventListener('error', later, { once: true });
            window.addEventListener('load', later, { once: true });
          }
          this.track.addEventListener('pointerdown', this.wake, { once: true, passive: true });
        }

        sync() {
          this.slides.forEach((slide, i) => (slide.inert = i !== this.index));
        }

        schedule() {
          clearTimeout(this.timer);
          if (document.hidden || this.held) return;
          const seconds = parseFloat(this.slides[this.index].dataset.seconds) || 8;
          this.timer = setTimeout(() => this.go((this.index + 1) % this.slides.length), seconds * 1000);
        }

        go(i, hold) {
          if (this.wake) this.wake();
          this.index = i;
          this.held = !!hold;
          this.sync();
          this.track.scrollTo({
            left: this.slides[i].offsetLeft - this.slides[0].offsetLeft,
            behavior: this.reduce.matches ? 'auto' : 'smooth',
          });
          this.schedule();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elzari-instagram"] && !Shopify.designMode) return;
  try {
    
  /* An app-fed section starts collapsed and opens only once the feed has
     rendered real posts. Anything else (feed request hanging on the
     spinner, an error, "No posts to show yet" on a product nothing is
     tagged to) leaves it collapsed, so shoppers never see a heading over
     an empty box. */
  document.querySelectorAll('[data-elz-ig-pending]').forEach((section) => {
    const hasPosts = () =>
      !!section.querySelector('.elz-ig__app img, .elz-ig__app video') &&
      !/no posts to show/i.test(section.querySelector('.elz-ig__app')?.textContent || '');
    const open = () => {
      section.classList.remove('elz-ig--pending');
      section.removeAttribute('data-elz-ig-pending');
    };
    if (hasPosts()) return open();
    const watcher = new MutationObserver(() => {
      if (hasPosts()) {
        watcher.disconnect();
        open();
      }
    });
    watcher.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elzari-main-product"]) return;
  try {
    
  if (!customElements.get('elz-product')) {
    customElements.define(
      'elz-product',
      class ElzProduct extends HTMLElement {
        connectedCallback() {
          try {
            this.variants = JSON.parse(this.querySelector('[data-elz-variants]').textContent);
          } catch (e) {
            this.variants = [];
          }
          this.initEta();
          this.mainEl = this.querySelector('.elz-pdp__main');
          this.initDots();
          this.warmGallery();
          this.querySelector('[data-elz-zoom]')?.addEventListener('click', () => this.openLightbox());
          this.querySelector('[data-elz-galprev]')?.addEventListener('click', () => this.galleryStep(-1));
          this.querySelector('[data-elz-galnext]')?.addEventListener('click', () => this.galleryStep(1));
          this.relocateSizeChart();
          this.initCodPlaceholder();
          this.initFastDelivery();
          this.initPromiseEchoes();
          this.selected = {};
          this.querySelectorAll('.elz-pdp__size--on').forEach((btn) => {
            this.selected[btn.dataset.elzOptidx] = btn.dataset.elzOptval;
          });
          this.querySelectorAll('[data-elz-thumb]').forEach((thumb) =>
            thumb.addEventListener('click', () => this.showMedia(thumb.dataset.mediaId, thumb))
          );
          this.querySelectorAll('.elz-pdp__size').forEach((btn) =>
            btn.addEventListener('click', (event) => {
              this.pickOption(btn);
              // Real taps only: the sticky bar mirrors its select via btn.click()
              if (event.isTrusted) this.revealBuy();
            })
          );
          this.restoreSize();
          // tell the sticky bar the starting sizes too
          const start = this.currentVariant();
          if (start && !window.elzVariantDetail) {
            const sizes = {};
            this.sizeGroups.forEach((g) => {
              sizes[g.dataset.elzOptionIndex] = this.selected[g.dataset.elzOptionIndex];
            });
            this.announceVariant({ sizes, available: start.available });
          }
        }

        // Kept on window as well, for a sticky bar that connects after this does
        announceVariant(detail) {
          window.elzVariantDetail = detail;
          document.dispatchEvent(new CustomEvent('elz:variant-change', { detail }));
        }

        // Size memory: the size(s) picked on this product come back when the
        // shopper returns in the same browser session (no ?variant= in the URL,
        // and only if that size, or bundle size combination, is in stock).
        get sizeGroups() {
          return [...this.querySelectorAll('[data-elz-size-group]')];
        }
        get sizeKey() {
          return `elzSize:${this.dataset.productId}`;
        }
        saveSizes() {
          const sizes = {};
          this.sizeGroups.forEach((g) => {
            const idx = g.dataset.elzOptionIndex;
            if (this.selected[idx]) sizes[idx] = this.selected[idx];
          });
          try {
            sessionStorage.setItem(this.sizeKey, JSON.stringify(sizes));
          } catch (e) {}
        }
        restoreSize() {
          const groups = this.sizeGroups;
          if (!groups.length || new URLSearchParams(window.location.search).has('variant')) return;
          let saved = null;
          try {
            saved = JSON.parse(sessionStorage.getItem(this.sizeKey) || 'null');
          } catch (e) {}
          if (!saved || typeof saved !== 'object') return;
          const wanted = { ...this.selected };
          const picks = [];
          groups.forEach((g) => {
            const idx = g.dataset.elzOptionIndex;
            const btn = [...g.querySelectorAll('.elz-pdp__size')].find((b) => b.dataset.elzOptval === saved[idx]);
            if (btn) {
              wanted[idx] = saved[idx];
              picks.push(btn);
            }
          });
          if (!picks.length || picks.every((b) => this.selected[b.dataset.elzOptidx] === b.dataset.elzOptval)) return;
          const variant = this.variants.find((v) => {
            const opts = [v.option1, v.option2, v.option3];
            return Object.entries(wanted).every(([i, val]) => opts[Number(i)] === val);
          });
          if (!variant || !variant.available) return;
          picks.forEach((btn) => this.markOption(btn));
          this.applyVariant();
        }

        initCodPlaceholder() {
          const buy = this.querySelector('[data-elz-buynow]');
          if (buy) buy.addEventListener('click', () => this.buyNow(buy));
          const stand = this.querySelector('[data-elz-codph]');
          if (!stand) return;
          const form = stand.closest('form');
          let wanted = false;
          const handOff = () => {
            const rsi = form.querySelector(':scope > #_rsi-buy-now-button, :scope > ._rsi-buy-now-button');
            if (!rsi) return false;
            // read at hand-off: the size on the label may have changed since load
            const label = stand.querySelector('span').textContent.trim();
            // Fallback for when Releasit built the button before the settings patch
            const text = rsi.querySelector('span');
            if (label && text && text.textContent.trim() !== label) text.textContent = label;
            stand.remove();
            if (wanted) rsi.click();
            return true;
          };
          stand.addEventListener('click', () => {
            wanted = true;
            stand.setAttribute('aria-busy', 'true');
          });
          if (handOff()) return;
          const watcher = new MutationObserver(() => {
            if (handOff()) watcher.disconnect();
          });
          watcher.observe(form, { childList: true });
          // Releasit off for this product (or the app disabled): drop the stand-in
          const giveUp = () =>
            setTimeout(() => {
              if (!stand.isConnected) return;
              watcher.disconnect();
              stand.remove();
            }, 6000);
          if (document.readyState === 'complete') giveUp();
          else window.addEventListener('load', giveUp, { once: true });
        }

        // Releasit off: Buy Now adds this item (size, quantity, Fast delivery,
        // all on the product form) and goes straight to Shopify checkout. The
        // card 5% cart attribute is cleared: it belongs to the cart's card button.
        async buyNow(btn) {
          const form = btn.closest('form');
          const add = this.querySelector('[data-elz-add]');
          if (!form || btn.disabled || (add && add.disabled)) return;
          const data = new FormData(form);
          if (!data.get('id')) return add && add.click();
          const errorWrap = this.querySelector('.elz-pdp__error');
          if (errorWrap) errorWrap.hidden = true;
          btn.setAttribute('aria-busy', 'true');
          btn.disabled = true;
          const release = () => {
            btn.removeAttribute('aria-busy');
            btn.disabled = false;
          };
          const route = (key, fallback) => `${(window.routes && window.routes[key]) || fallback}.js`.replace('.js.js', '.js');
          try {
            const res = await fetch(route('cart_add_url', '/cart/add'), {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: data,
            });
            const json = await res.json();
            if (!res.ok || json.status) {
              const message = errorWrap && errorWrap.querySelector('.product-form__error-message');
              if (message) {
                message.textContent = json.description || json.message || 'This item could not be added.';
                errorWrap.hidden = false;
              }
              return release();
            }
            await fetch(route('cart_update_url', '/cart/update'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { _scaladiscount: '' } }),
            }).catch(() => {});
            window.location.href = '/checkout';
            // back-forward cache or a blocked navigation: give the button back
            setTimeout(release, 6000);
          } catch (e) {
            release();
          }
        }

        // Size picked on mobile: bring the buy buttons (Add to cart + COD below it)
        // into view and pulse Add to cart once. Only ever scrolls down, never away.
        revealBuy() {
          if (!window.matchMedia('(max-width: 760px)').matches) return;
          const cod = this.querySelector('.elz-pdp__formtag > ._rsi-buy-now-button, .elz-pdp__formtag #_rsi-buy-now-button, .elz-pdp__formtag > .elz-pdp__codph');
          const target = cod || this.querySelector('[data-elz-add]');
          if (!target) return;
          const rect = target.getBoundingClientRect();
          const overflow = rect.bottom - window.innerHeight + 20;
          if (overflow > 0 && rect.top > 0) {
            const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            window.scrollBy({ top: overflow, behavior: reduce ? 'auto' : 'smooth' });
          }
          const add = this.querySelector('[data-elz-add]');
          if (add && !add.disabled) {
            add.classList.remove('elz-nudge');
            void add.offsetWidth;
            add.classList.add('elz-nudge');
          }
        }

        // The money-back promise inside the apps' own UI: a line under the
        // Releasit COD form header, and the trust-badges app's
        // "Easy Returns" label renamed to match (both render after load).
        initPromiseEchoes() {
          const title = this.dataset.promiseTitle;
          if (!title) return;
          const text = this.dataset.promiseText || '';
          const badge = this.dataset.promiseBadge;
          const apply = () => {
            const header = document.querySelector('#_rsi-cod-form-modal-form ._rsi-modal-header');
            if (header && !header.parentElement.querySelector('.elz-rsi-promise')) {
              const line = document.createElement('div');
              line.className = 'elz-rsi-promise';
              line.innerHTML =
                '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="m9 12 2 2 4-4"/></svg>';
              const words = document.createElement('span');
              const strong = document.createElement('strong');
              strong.textContent = title + '. ';
              words.append(strong, document.createTextNode(text));
              line.appendChild(words);
              header.insertAdjacentElement('afterend', line);
            }
            if (badge) {
              this.querySelectorAll('.essential-banners-block .title').forEach((el) => {
                if (/^easy returns$/i.test(el.textContent.trim())) el.textContent = badge;
              });
            }
          };
          apply();
          const watcher = new MutationObserver(apply);
          watcher.observe(document.body, { childList: true, subtree: true });
          setTimeout(() => watcher.disconnect(), 120000);
        }

        initFastDelivery() {
          const box = this.querySelector('.elz-fastdel__input');
          if (!box) return;
          const sync = () => {
            this.querySelectorAll('[data-elz-eta]').forEach((eta) => {
              if (box.checked) {
                eta.dataset.deliverMinStd = eta.dataset.deliverMinStd || eta.dataset.deliverMin;
                eta.dataset.deliverMaxStd = eta.dataset.deliverMaxStd || eta.dataset.deliverMax;
                eta.dataset.deliverMin = box.dataset.fastMin;
                eta.dataset.deliverMax = box.dataset.fastMax;
              } else if (eta.dataset.deliverMinStd) {
                eta.dataset.deliverMin = eta.dataset.deliverMinStd;
                eta.dataset.deliverMax = eta.dataset.deliverMaxStd;
              }
              eta.classList.toggle('elz-eta--fast', box.checked);
            });
            this.initEta();
          };
          box.addEventListener('change', sync);
          if (box.checked) sync();

          // Releasit's Buy Now form builds its own order (product only), so the
          // product form's properties never reach it. Its documented pre-submit
          // hook gets the form data; add the property to each item there, in
          // the same item_properties[n] JSON it sends for cart orders.
          const propName = box.name.replace(/^properties\[|\]$/g, '');
          const previous = window._COD_FORM_OVERWRITE_ON_SUBMIT_START;
          window._COD_FORM_OVERWRITE_ON_SUBMIT_START = function (formData) {
            try {
              // cart-mode orders (COD from the cart) already carry each line's own
              // Fast delivery property from add-to-cart
              const cartMode = window._rsi && window._rsi.form && window._rsi.form.mode === 'normalCart';
              if (box.checked && !cartMode && Array.isArray(formData)) {
                const indexes = formData
                  .map((field) => (/^item_variant_id\[(\d+)\]$/.exec(field.name) || [])[1])
                  .filter((n) => n !== undefined);
                indexes.forEach((n) => {
                  const key = `item_properties[${n}]`;
                  let field = formData.find((f) => f.name === key);
                  if (!field) {
                    field = { name: key, value: '{}' };
                    formData.push(field);
                  }
                  let props = {};
                  try {
                    props = JSON.parse(field.value || '{}') || {};
                  } catch (e) {}
                  props[propName] = box.value;
                  field.value = JSON.stringify(props);
                });
              }
            } catch (e) {}
            return typeof previous === 'function' ? previous(formData) : true;
          };
        }

        initEta() {
          this.querySelectorAll('[data-elz-eta]').forEach((eta) => {
            // Standard times are working days (couriers don't deliver on
            // Sundays); the fast-delivery window keeps plain days.
            const working = eta.dataset.workingDays === 'true' && !eta.classList.contains('elz-eta--fast');
            const fmt = (offset) => {
              const d = new Date();
              if (working) {
                let left = offset;
                while (left > 0) {
                  d.setDate(d.getDate() + 1);
                  if (d.getDay() !== 0) left -= 1;
                }
              } else {
                d.setDate(d.getDate() + offset);
              }
              return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
            };
            const dMin = parseInt(eta.dataset.dispatchMin, 10) || 0;
            const dMax = parseInt(eta.dataset.dispatchMax, 10) || 1;
            const vMin = parseInt(eta.dataset.deliverMin, 10) || 2;
            const vMax = parseInt(eta.dataset.deliverMax, 10) || 4;
            eta.querySelector('[data-eta-window]').textContent = `${fmt(vMin)} – ${fmt(vMax)}`;
            eta.querySelector('[data-eta-ordered]').textContent = fmt(0);
            eta.querySelector('[data-eta-dispatched]').textContent = dMin === dMax ? fmt(dMin) : `${fmt(dMin)} – ${fmt(dMax)}`;
            eta.querySelector('[data-eta-delivered]').textContent = `${fmt(vMin)} – ${fmt(vMax)}`;
          });
        }

        initDots() {
          const wrap = this.querySelector('[data-elz-dots]');
          if (!wrap || !this.mainEl) return;
          const imgs = this.querySelectorAll('[data-elz-main-img]');
          imgs.forEach((_, i) => {
            const dot = document.createElement('span');
            dot.className = 'elz-pdp__dot' + (i === 0 ? ' elz-pdp__dot--on' : '');
            wrap.appendChild(dot);
          });
          this.mainEl.addEventListener(
            'scroll',
            () => {
              const index = Math.round(this.mainEl.scrollLeft / this.mainEl.clientWidth);
              wrap.querySelectorAll('.elz-pdp__dot').forEach((dot, i) =>
                dot.classList.toggle('elz-pdp__dot--on', i === index)
              );
              const count = this.querySelector('[data-elz-count]');
              if (count) count.textContent = `${index + 1} / ${imgs.length}`;
            },
            { passive: true }
          );
        }

        fillImg(img) {
          if (!img || !img.dataset.srcset) return;
          img.loading = 'eager';
          img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-src');
        }

        warmGallery() {
          // The inline script after the photo strip schedules photos 2+ (see its
          // comment). Here: touching, scrolling or hovering the gallery fills them
          // all at once, and if that script didn't run, the page load does.
          const imgs = [...this.querySelectorAll('[data-elz-main-img][data-srcset]')];
          if (!imgs.length) return;
          const warmRest = () => imgs.forEach((img) => this.fillImg(img));
          if (!this.mainEl?.hasAttribute('data-elz-warm')) {
            if (document.readyState === 'complete') warmRest();
            else window.addEventListener('load', warmRest, { once: true });
          }
          this.querySelector('.elz-pdp__gallery')?.addEventListener('pointerdown', warmRest, { once: true, passive: true });
          this.mainEl?.addEventListener('scroll', warmRest, { once: true, passive: true });
          this.querySelector('.elz-pdp__frame')?.addEventListener('mouseenter', warmRest, { once: true });
        }

        openLightbox() {
          const imgs = [...this.querySelectorAll('[data-elz-main-img]')];
          let active;
          if (window.matchMedia('(max-width: 760px)').matches) {
            active = imgs[Math.round(this.mainEl.scrollLeft / this.mainEl.clientWidth)] || imgs[0];
          } else {
            active = imgs.find((img) => !img.hidden) || imgs[0];
          }
          if (!active) return;
          this.fillImg(active);
          const overlay = document.createElement('div');
          overlay.className = 'elz-lightbox';
          overlay.innerHTML =
            '<button type="button" class="elz-lightbox__close" aria-label="Close">✕</button>' +
            '<div class="elz-lightbox__scroll"><img alt=""></div>';
          overlay.querySelector('img').src = active.currentSrc || active.src;
          overlay.querySelector('img').addEventListener('click', () => overlay.classList.toggle('elz-lightbox--zoom'));
          const close = () => {
            overlay.remove();
            document.removeEventListener('keydown', onKey);
          };
          const onKey = (e) => e.key === 'Escape' && close();
          overlay.querySelector('.elz-lightbox__close').addEventListener('click', close);
          overlay.addEventListener('click', (e) => {
            if (e.target === overlay || e.target.classList.contains('elz-lightbox__scroll')) close();
          });
          document.addEventListener('keydown', onKey);
          document.body.appendChild(overlay);
        }

        relocateSizeChart() {
          const label = this.querySelector('.elz-pdp__optlabel');
          if (!label) return;
          const move = () => {
            const link = this.querySelector('.elz-pdp__formtag .mpsc-inline-btn');
            if (!link) return false;
            const wrapper = link.parentElement;
            label.appendChild(link);
            if (wrapper && wrapper.children.length === 0) wrapper.remove();
            return true;
          };
          if (move()) return;
          const watcher = new MutationObserver(() => {
            if (move()) watcher.disconnect();
          });
          watcher.observe(this, { childList: true, subtree: true });
          setTimeout(() => watcher.disconnect(), 12000);
        }

        galleryStep(dir) {
          const imgs = [...this.querySelectorAll('[data-elz-main-img]')];
          if (imgs.length < 2) return;
          let current = imgs.findIndex((img) => !img.hidden);
          if (window.matchMedia('(max-width: 760px)').matches) {
            current = Math.round(this.mainEl.scrollLeft / this.mainEl.clientWidth);
          }
          const next = (current + dir + imgs.length) % imgs.length;
          this.showMedia(imgs[next].dataset.mediaId);
        }

        showMedia(mediaId, thumb) {
          const mobile = window.matchMedia('(max-width: 760px)').matches;
          this.querySelectorAll('[data-elz-main-img]').forEach((img) => {
            img.hidden = img.dataset.mediaId !== String(mediaId);
            if (!img.hidden) this.fillImg(img);
            if (mobile && img.dataset.mediaId === String(mediaId)) {
              img.parentElement.scrollTo({ left: img.offsetLeft, behavior: 'smooth' });
            }
          });
          this.querySelectorAll('[data-elz-thumb]').forEach((t) =>
            t.classList.toggle('elz-pdp__thumb--active', t === thumb || t.dataset.mediaId === String(mediaId))
          );
          const count = this.querySelector('[data-elz-count]');
          if (count) {
            const imgs = [...this.querySelectorAll('[data-elz-main-img]')];
            const index = imgs.findIndex((img) => img.dataset.mediaId === String(mediaId));
            if (index > -1) count.textContent = `${index + 1} / ${imgs.length}`;
          }
        }

        pickOption(btn) {
          this.markOption(btn);
          if (btn.closest('[data-elz-size-group]')) this.saveSizes();
          this.applyVariant();
        }

        markOption(btn) {
          this.selected[btn.dataset.elzOptidx] = btn.dataset.elzOptval;
          btn.closest('.elz-pdp__sizes')
            .querySelectorAll('.elz-pdp__size')
            .forEach((b) => {
              const on = b === btn;
              b.classList.toggle('elz-pdp__size--on', on);
              b.setAttribute('aria-checked', on ? 'true' : 'false');
            });
        }

        currentVariant() {
          return this.variants.find((variant) => {
            const opts = [variant.option1, variant.option2, variant.option3];
            return Object.entries(this.selected).every(([idx, val]) => opts[Number(idx)] === val);
          });
        }

        applyVariant() {
          const variant = this.currentVariant();
          const addBtn = this.querySelector('[data-elz-add]');
          const label = this.querySelector('[data-elz-add-label]');
          const price = this.querySelector('[data-elz-price]');
          const was = this.querySelector('[data-elz-was]');
          const save = this.querySelector('[data-elz-save]');
          const saveAmount = this.querySelector('[data-elz-save-amount]');
          const idInput = this.querySelector('[data-elz-variant-id]');
          const money = (cents) => {
            const format = this.dataset.moneyFormat || 'Rs.[amount]';
            const amount = (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2 });
            return format.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace('[amount]', amount);
          };
          const buyNow = this.querySelector('[data-elz-buynow]');
          if (!variant) {
            addBtn.disabled = true;
            if (buyNow) buyNow.disabled = true;
            label.textContent = window.variantStrings.unavailable;
            return;
          }
          idInput.value = variant.id;
          idInput.disabled = false;
          price.textContent = money(variant.price);
          const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          was.hidden = !onSale;
          save.hidden = !onSale;
          if (onSale) {
            was.textContent = money(variant.compare_at_price);
            saveAmount.textContent = money(variant.compare_at_price - variant.price);
          }
          addBtn.disabled = !variant.available;
          if (buyNow) buyNow.disabled = !variant.available;
          label.textContent = variant.available
            ? window.variantStrings.addToCart + ' +'
            : window.variantStrings.soldOut;
          // the sticky bar follows: its size select and sold-out state
          const sizes = {};
          this.sizeGroups.forEach((g) => {
            sizes[g.dataset.elzOptionIndex] = this.selected[g.dataset.elzOptionIndex];
          });
          this.announceVariant({ sizes, available: variant.available });
          if (variant.featured_media) this.showMedia(variant.featured_media.id);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
    );
  }

  if (!customElements.get('elz-buywith')) {
    customElements.define(
      'elz-buywith',
      class ElzBuyWith extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-elz-biw-track]');
          const dotsWrap = this.querySelector('[data-elz-biw-dots]');
          const cards = this.track ? [...this.track.querySelectorAll('.elz-biw__card')] : [];
          if (!this.track || !dotsWrap || cards.length < 2) return;
          cards.forEach((card, i) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'elz-biw__dot' + (i === 0 ? ' elz-biw__dot--on' : '');
            dot.setAttribute('aria-label', `Show suggestion ${i + 1} of ${cards.length}`);
            dot.addEventListener('click', () =>
              this.track.scrollTo({ left: card.offsetLeft - cards[0].offsetLeft, behavior: 'smooth' })
            );
            dotsWrap.appendChild(dot);
          });
          this.track.addEventListener(
            'scroll',
            () => {
              // Step is measured per event: at connect time the carousel is
              // not laid out yet and every offsetLeft reads 0.
              const step = cards[1].offsetLeft - cards[0].offsetLeft || this.track.clientWidth || 1;
              const index = Math.min(cards.length - 1, Math.max(0, Math.round(this.track.scrollLeft / step)));
              dotsWrap.querySelectorAll('.elz-biw__dot').forEach((dot, i) =>
                dot.classList.toggle('elz-biw__dot--on', i === index)
              );
            },
            { passive: true }
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
